import React from 'react';
import Card from 'react-bootstrap/Card';


interface commonCardprops {
    cardHeader?:string;
    cardHeaderContent?:any;
    cardBodyContent?:any;
}
const CommonCardComponent: React.FC<commonCardprops> = ({
  cardHeader,
  cardHeaderContent, 
  cardBodyContent
}) => {
  return (
    <div className="common_card_component">
      <Card className="common_entire_card">
        <Card.Header className="common_card_header">{cardHeader}{cardHeaderContent} </Card.Header>
        <Card.Body className="common_card_body">{cardBodyContent}</Card.Body>
      </Card>
    </div>
  );
};
export default CommonCardComponent;
